export const styles = {
  content: {
    minHeight: '83vh',
    width: '100%',
  },
  fullMapcontent: {
    minHeight: '100vh',
    width: '92vw',
  },
  mapDiv: {
    padding: '0 0 0 0',
    margin: '0 0 0 0',
    height: '100%',
    width: '100%',
  },
  button: {
    position: 'absolute',
    zIndex: '1000',
    left: '100px',
    float: 'right',
  },
};

export const markerSymbol: any = {
  type: 'simple-marker', // autocasts as new SimpleMarkerSymbol()
  style: 'square',
  color: [51, 204, 51, 0],
  size: '24px', // pixels
  outline: {
    // autocasts as new SimpleLineSymbol()
    color: [0, 255, 255],
    width: 3, // points
  },
};
